export default __webpack_public_path__ + "static/media/zawodnik13.88a15a0a.png";